import useGlobalStyles from '@/styles/global.styles';
import { brandColors } from '@/styles/theme/values/brandColors';

type ArticleInfoProps = {
  readingTime: number;
  classname?: string;
  textColor?: string;
};

const ArticleInfo = ({
  readingTime,
  classname,
  textColor = brandColors.tintsNeutral20,
}: ArticleInfoProps) => {
  const { classes: globalClasses, cx } = useGlobalStyles({ fixed: true });

  return (
    <span
      className={cx(globalClasses.body, classname)}
      style={{ color: textColor }}
    >{`${readingTime} min read`}</span>
  );
};

export default ArticleInfo;
